import moment = require('moment');
import * as React from 'react';

import CalendarText from '../../contexts/calendar-text';
import { formatDateTime } from '../../helpers/format-date-time';
import { IMonth, IEvent } from '../../interfaces';
import ListDayView from './day.view';
import ListProductionView from './production.view';

interface IListMonthViewProps {
    monthData: IMonth<IEvent>;
    currentScrolledDate: moment.Moment;
    selectedFromMiniCalendar: boolean;
    dateSelectedFromMiniCalendar: moment.Moment;
}

/**
 * Container for a month, slightly different view based on whether or not there are events.
 */
class ListMonthView extends React.PureComponent<IListMonthViewProps> {
    render(): React.ReactNode {
        const hasEvents = this.props.monthData.events.days.some(day => day.events.length > 0);
        return (
            <CalendarText.Consumer>
                {text => (
                    hasEvents
                        ? (
                            <li className="ace-cal-list-month" data-monthmoment={this.props.monthData.monthMoment.format('YYYY-MM')}>
                                <h3 id={`Month-List-${this.props.monthData.monthMoment.format("X")}`} className="ace-cal-list-month-name h2-style">{formatDateTime(this.props.monthData.monthMoment, text.accessibleMonthFormat)}</h3>
                                <article className="stack">
                                    <ul className="stack-sm" aria-labelledby={`Month-List-${this.props.monthData.monthMoment.format("X")}`}>
                                        {
                                            this.props.monthData.events.productions
                                                .sort((a, b) => {
                                                    if (a.events.length == 0) {
                                                        return -1;
                                                    }

                                                    if (b.events.length == 0) {
                                                        return 1;
                                                    }
                                                    return moment(a.events[0].eventDate).isBefore(b.events[0].eventDate) ? -1 : 1;
                                                }).map(prod => <ListProductionView key={prod.id} production={prod} selectedFromMiniCalendar={this.props.selectedFromMiniCalendar} dateSelectedFromMiniCalendar={this.props.dateSelectedFromMiniCalendar} openProdList={prod.events.filter(ev => moment(ev.eventDate).startOf('day').format('X') === this.props.currentScrolledDate.format('X')).length > 0} />)
                                        }
                                    </ul>
                                </article>
                            </li>
                        ) : (
                            <li className="ace-cal-list-month ace-cal-list-month-empty" data-monthmoment={this.props.monthData.monthMoment.format('YYYY-MM')}>
                                <article>
                                    <h3 id={`Month-List-${this.props.monthData.monthMoment.format("X")}`} className="ace-cal-list-month-name h2-style">{formatDateTime(this.props.monthData.monthMoment, text.accessibleMonthFormat)}</h3>
                                    <div className="ace-cal-list-days-empty" dangerouslySetInnerHTML={{ __html: text.emptyMonthMessage }} aria-labelledby={`Month-List-${this.props.monthData.monthMoment.format("X")}`}></div>
                                </article>
                            </li>
                        )
                )}
            </CalendarText.Consumer>
        );
    }
}

export default ListMonthView;